import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header-placa',
  templateUrl: './header-placa.component.html',
  styleUrls: ['./header-placa.component.scss']
})
export class HeaderPlacaComponent implements OnInit {

  @Input() cabecalho;
  placaMercosul;
  emplacamento;
  
  constructor() { }

  ngOnInit() {
    this.setEmplacamento();
    this.placaMercosul = this.cabecalho.placaMercosul || false;
  }

  setEmplacamento() {
    if (this.cabecalho) {
      let uf = this.cabecalho.uf || this.cabecalho.ufMunicipio || 'UF';
      let municipio = this.cabecalho.municipio || 'MUNICIPIO';
      this.emplacamento = uf + ' - ' + municipio;
    }
    this.emplacamento !== 'UF - MUNICIPIO' ? this.emplacamento = this.emplacamento : this.emplacamento = null;
  }

}
